/* Solvra — JS propio. Vanilla, sin librerías. Cada init comprueba si su
   elemento existe, así el mismo archivo sirve para todas las páginas. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Animaciones de entrada al hacer scroll */
  function initReveal() {
    var els = document.querySelectorAll('.sv-reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('sv-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sv-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Galería de la página de producto: cambiar la imagen principal */
  function initGallery() {
    var gallery = document.querySelector('[data-sv-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-sv-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-sv-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (full) main.setAttribute('src', full);
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* Selector de variantes (solo si hay más de una) */
  function initVariants() {
    var form = document.querySelector('[data-sv-product-form]');
    if (!form) return;
    var dataEl = form.querySelector('[data-sv-variants]');
    var select = form.querySelector('[data-sv-variant-select]');
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-sv-price]');
    var button = form.querySelector('[data-sv-add]');
    if (!dataEl || !select || !idInput) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    function money(cents) {
      var v = (cents / 100).toFixed(2).replace('.', ',');
      return v + ' €';
    }
    select.addEventListener('change', function () {
      var v = variants.find(function (x) { return String(x.id) === String(select.value); });
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (button) {
        button.disabled = !v.available;
        button.textContent = v.available ? button.getAttribute('data-label-add') : button.getAttribute('data-label-sold');
      }
    });
  }

  /* Parallax / tilt 3D suave del hero y de la imagen de producto.
     Solo con ratón fino; respeta reduced-motion; se activa cuando la zona
     es visible. Vanilla, sin librerías. Escribe solo transform (GPU). */
  function initTilt() {
    if (reduceMotion) return;
    if (typeof requestAnimationFrame !== 'function') return;
    if (!window.matchMedia || !window.matchMedia('(pointer: fine)').matches) return;

    var targets = [];
    var pmain = document.querySelector('.sv-pgallery__main');
    if (pmain) targets.push({ zone: pmain, el: pmain, maxRot: 2, maxShift: 3, floaty: false });
    if (!targets.length) return;

    targets.forEach(function (t) {
      t.tx = t.ty = t.rx = t.ry = 0;       // valores actuales
      t.dtx = t.dty = t.drx = t.dry = 0;   // objetivos
      t.visible = true;

      if ('IntersectionObserver' in window) {
        t.visible = false;
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { t.visible = e.isIntersecting; });
        }, { threshold: 0.05 }).observe(t.zone);
      }

      t.zone.addEventListener('mouseenter', function () { t.el.style.willChange = 'transform'; });
      t.zone.addEventListener('mousemove', function (ev) {
        var r = t.zone.getBoundingClientRect();
        var px = (ev.clientX - r.left) / r.width - 0.5;   // -0.5 .. 0.5
        var py = (ev.clientY - r.top) / r.height - 0.5;
        t.dry = px * t.maxRot * 2;
        t.drx = -py * t.maxRot * 2;
        t.dtx = px * t.maxShift;
        t.dty = py * t.maxShift;
      }, { passive: true });
      t.zone.addEventListener('mouseleave', function () {
        t.dtx = t.dty = t.drx = t.dry = 0;
        t.el.style.willChange = 'auto';
      });
    });

    var t0 = null;
    function frame(ts) {
      if (t0 === null) t0 = ts;
      var s = (ts - t0) / 1000;
      targets.forEach(function (t) {
        var fy = t.floaty ? Math.sin(s * 0.9) * 4 : 0;      // flotación idle sutil
        var fr = t.floaty ? Math.sin(s * 0.7) * 0.4 : 0;
        t.tx += (t.dtx - t.tx) * 0.08;
        t.ty += (t.dty - t.ty) * 0.08;
        t.rx += (t.drx - t.rx) * 0.08;
        t.ry += (t.dry - t.ry) * 0.08;
        if (!t.visible) return;
        t.el.style.transform =
          'translate3d(' + t.tx.toFixed(2) + 'px,' + (t.ty + fy).toFixed(2) + 'px,0) rotateX(' +
          (t.rx + fr).toFixed(2) + 'deg) rotateY(' + t.ry.toFixed(2) + 'deg)';
        if (t.glow) t.glow.style.transform = 'translate3d(' + (-t.tx * 1.6).toFixed(2) + 'px,' + (-t.ty * 1.6).toFixed(2) + 'px,0)';
        if (t.tag) t.tag.style.transform = 'translate3d(' + (t.tx * 1.4).toFixed(2) + 'px,' + (t.ty * 1.4).toFixed(2) + 'px,0)';
      });
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function boot() {
    initReveal();
    initGallery();
    initVariants();
    initTilt();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
